import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface ConversationSummaryDetailsSubsectionProps {
  title: ReactNode;
  content: ReactNode;
  paddingTop?: number;
}

/*
 * Styles.
 */

export const StyledDetailsSubsectionListDiv = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-row-gap: 10px;
  align-items: center;
`;

const defaultPaddingTop = 18;

interface DetailsSectionStyleProps {
  $paddingTop: number;
}
const StyledDetailsSectionDiv = styled.div<DetailsSectionStyleProps>`
  padding-top: ${(p) => p.$paddingTop}px;

  &:first-child {
    padding-top: 0px;
  }
`;

const StyledTitleDiv = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.semibold};
  color: ${(p) => p.theme.greys.shade80};
  padding-bottom: 9px;
`;

/*
 * Component.
 */

export const ConversationSummaryDetailsSubsection: FC<ConversationSummaryDetailsSubsectionProps> = (
  props,
) => (
  <StyledDetailsSectionDiv $paddingTop={props.paddingTop ?? defaultPaddingTop}>
    <StyledTitleDiv>{props.title}</StyledTitleDiv>
    {props.content}
  </StyledDetailsSectionDiv>
);
